import { BalconyContainer } from '../../containers/advancedFilters/BalconyContainer';
import { IFilter } from '../../types/advancedFilters';

export const balcony: IFilter = {
  component: BalconyContainer,
};
